import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      dark: {
        primary: "#fcaf17",
        success: "#006000",
        error: "#a1003a",
        blue_darken_4: "#003784",
        button_text: "#1A1918",
      },
    },
    dark: true,
  },
});
